import {Map, Polygon} from '@Map';
import markerImage from 'assets/images/map/pin-vendor.png';
import {memo} from 'react';
import type {MapLayerMouseEvent} from 'react-map-gl/maplibre';
import {Marker} from 'react-map-gl/maplibre';

import type {DeliveryMethod, MapCenter, ServiceAreaPolygon} from '../../types';

type ServiceAreaMapProps = {
  center?: MapCenter;
  deliveryMethod: DeliveryMethod;
  polygons: ServiceAreaPolygon[];
  selectedPolygonId: string | number | null;
  onClick: (event: MapLayerMouseEvent) => void;
  onMouseEnter: (event: MapLayerMouseEvent) => void;
  onMouseLeave: (event: MapLayerMouseEvent) => void;
};

const INTERACTIVE_LAYER_IDS = ['custom-polygon-fill', 'custom-polygon-highlight'];

const ServiceAreaMap: React.FC<ServiceAreaMapProps> = ({
  center,
  deliveryMethod,
  polygons,
  selectedPolygonId,
  onClick,
  onMouseEnter,
  onMouseLeave
}) => {
  if (!center) return null;

  const visiblePolygons =
    deliveryMethod === 'express'
      ? polygons.map((polygon) => ({
          ...polygon,
          polygonColor: 'var(--color-orange)',
          isActivated: true
        }))
      : polygons;

  return (
    <Map
      centerLat={center.latitude}
      centerLong={center.longitude}
      zoom={13}
      interactiveLayerIds={INTERACTIVE_LAYER_IDS}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Marker longitude={center.longitude} latitude={center.latitude}>
        <img className="size-12.5" src={markerImage} alt="موقعیت فروشگاه" />
      </Marker>
      {visiblePolygons.length > 0 && (
        <Polygon
          data={visiblePolygons}
          selectedPolygonId={
            deliveryMethod === 'own' ? (selectedPolygonId ?? undefined) : undefined
          }
        />
      )}
    </Map>
  );
};

export default memo(ServiceAreaMap);
